/**
 * Scheme-allowlist for URLs bound to href/src in Lit templates.
 *
 * Lit does NOT sanitize URL schemes, so a `javascript:` (or `data:`/`vbscript:`)
 * URL arriving in catalog data (product `url` / `image_url` from a feed) would
 * become an executable link / active resource. Only http(s), mailto, tel and
 * scheme-less (relative) URLs are allowed through; anything else returns ''.
 */
const ALLOWED_SCHEMES = /^(https?|mailto|tel)$/i;

export function safeUrl(url: string | null | undefined): string {
  if (url == null) return '';
  const s = String(url).trim();
  const scheme = s.match(/^([a-z][a-z0-9+.-]*):/i);
  // A scheme that isn't in the allowlist (javascript:, data:, vbscript:, file:…) → drop.
  if (scheme && !ALLOWED_SCHEMES.test(scheme[1])) return '';
  return s;
}
